/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackid200,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackid401,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackid404,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidPathParams,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidQueryResponse,
} from "../../types/classPlanningFeedbacksController/GetApiV1ClassroomdisciplineIdFeedbacksFeedbackid.ts";
import { feedbackDetailViewModelSchema } from "../feedbackDetailViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    feedbackId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackid200Schema = z.lazy(
  () => feedbackDetailViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackid401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackid404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackid404>;

export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdFeedbacksFeedbackid200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidQueryResponse>;
